const AnimateInViewClass = {
    Base: 'AnimateInView',
    InView: 'InView',
    OffScreen: 'OffScreen',
    Cancel: 'Cancel',
    DesignMode: 'DesignMode'
}

function OnIntersection(elements, Observer) {
  elements.forEach(element => {
    const ElementTarget = element.target
    if (element.isIntersecting) {
      ElementTarget.classList.remove(AnimateInViewClass.OffScreen)
      ElementTarget.classList.add(AnimateInViewClass.InView)
      const HasCascade =ElementTarget.hasAttribute('data-cascade')
      const HasCascadeMobile =ElementTarget.hasAttribute('data-cascade-mobile')
      
      if (HasCascade, HasCascadeMobile) {
        ElementTarget.setAttribute('style', `${HasCascade ? `--AnimationDelay: ${parseInt(ElementTarget.dataset.cascade)};`: ''}${HasCascadeMobile ? `--AnimationDelayMobile: ${parseInt(ElementTarget.dataset.cascadeMobile)};`: ''}`)
      }

      Observer.unobserve(ElementTarget)
    } else {
      ElementTarget.classList.add(AnimateInViewClass.OffScreen)
      ElementTarget.classList.remove(AnimateInViewClass.InView)
      ElementTarget.classList.remove(AnimateInViewClass.Cancel)
    }
  })
}

function InitializeAnimationElements(RootElement = document, IsDesignMode = false) {
  const ElementsToAnimate = Array.from(RootElement.getElementsByClassName(AnimateInViewClass.Base));
  if (ElementsToAnimate.length <= 0) return;

  if (IsDesignMode) {
    ElementsToAnimate.forEach(ElementToAnimate => ElementToAnimate.classList.add(AnimateInViewClass.DesignMode))
  }
  const Observer = new IntersectionObserver(OnIntersection, {
    rootMargin: '0px 0px 0px 0px',
  })

  ElementsToAnimate.forEach(ElementToAnimate => {
    if (ElementToAnimate.hasAttribute('data-cascade')) {
        ElementToAnimate.setAttribute('style', `--AnimationDelay: ${parseInt(ElementToAnimate.dataset.cascade)};`)
    }
  })
  ElementsToAnimate.forEach(ElementToAnimate => Observer.observe(ElementToAnimate))
}

function InitializeGridCascades() {
  // Query elements with data-cascade-children property
  const cascadeChildrenElements = document.querySelectorAll('[data-grid-cascade]')

  cascadeChildrenElements.forEach(parentElement => {
    // Query direct children of the current parent element
    const children = parentElement.children
    
    for(let i = 0; i < children.length; i++) {
      const MaxDelay = i % theme?.Settings.GridProductsPerRow || 0
      const MaxDelayMobile = i % theme?.Settings.GridProductsPerRowMobile || 0
      children[i].dataset.cascade = MaxDelay
      children[i].dataset.cascadeMobile = MaxDelayMobile
    }
  })
}

window.addEventListener('DOMContentLoaded', () => {
  InitializeGridCascades?.()
  InitializeAnimationElements?.()
})

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => InitializeAnimationElements(event.target, true))
  document.addEventListener('shopify:section:reorder', () => InitializeAnimationElements(document, true))
}